<script>
  import { onMount } from 'svelte';
  import ImageProductCard from './ImageProductCard.svelte';
  import Rating from './Rating.svelte';
  import trackCheckBox from '../events/trackCheckBox.js';
  import trackBundleClick from '../events/trackBundleClick.js';

  /**
 *
 *
 *
 *
 *
 *
 */
  /*                */
  let { recommendation, featureIndex, widgetTracking, widgetAdditionalClickTracking, toggleCheck } =
    $props();

  const {
    _embedded: { 'o:variation': variation },
    brandName,
    formattedPrice,
    image,
    tracking,
    additionalClickTracking
  } = recommendation;

  const variationDetailViewUrl = variation._links['o:variation-detail-view-url']?.href;
  const baseDetailViewUrl = variation._links['o:base-detail-view-url']?.href;

  let checked = $state(true);
  const toggleCheckBox = () => {
    checked = !checked;
    trackCheckBox(
      widgetTracking,
      widgetAdditionalClickTracking,
      tracking,
      additionalClickTracking,
      featureIndex,
      checked
    );
    toggleCheck(variation.id, variation.pricing.retailPrice, checked);
  };

  const viewProductListener = () => {
    trackBundleClick(
      widgetTracking,
      widgetAdditionalClickTracking,
      tracking,
      additionalClickTracking,
      featureIndex
    );
  };

  onMount(() => {
    o_global.eventQBus.on('ft1.order-core.addToBasketResult', () => {});
  });
</script>

<oc-row-v2 hide-divider>
  <div
    class="reco_aos_product_bundle_item"
    data-tracking={`{"promo_Source":"${tracking?.labels?.promo_Source}"}`}>
    <oc-checkbox-v1
      data-testid="select_product_{variation.name}"
      class="reco_aos_product_bundle_item__checkbox oc-mr-150"
      name="select_product_{variation.name}"
      value="on"
      {checked}
      onoc-property-change={toggleCheckBox}
      variant="default"></oc-checkbox-v1>
    <oc-link-v2
      variant="secondary"
      class="reco_aos_product_bundle_item__oc-link"
      base64-href={btoa(variationDetailViewUrl)}>
      <a
        class="reco_aos_product_bundle_item__link"
        href={baseDetailViewUrl}
        onclick={viewProductListener}>
        <div
          class="reco_aos_product_bundle_item__parent_container"
          data-testid="reco_aos_product_bundle_item">
          <div class="reco_aos_product_bundle_item__left_side">
            <ImageProductCard {image} description={variation.name} isBundle={true} />
            <div class="reco_aos_product_bundle_item_container">
              <div class="oc-copy-75 reco_aos_product_bundle_item__name">
                {brandName}
                {variation.name}
              </div>
              <Rating {variation} />
            </div>
          </div>

          <div class="reco_aos_product_bundle_item__right_side">
            {#if formattedPrice.originalPrice === undefined || formattedPrice.retailPrice === formattedPrice.originalPrice}
              <div class="oc-copy-100 oc-copy--bold">{formattedPrice.retailPrice}</div>
            {:else}
              <div class="color-red oc-copy-100 oc-copy--bold">
                {formattedPrice.retailPrice}
              </div>
              <div class="line-through oc-copy-75">{formattedPrice.originalPrice}</div>
            {/if}
          </div>
        </div>
      </a>
    </oc-link-v2>
  </div>
</oc-row-v2>

<style lang="scss">
  .reco_aos_product_bundle_item {
    display: flex;
  }

  .reco_aos_product_bundle_item__checkbox {
    padding-top: 18px;
  }

  .reco_aos_product_bundle_item_container {
    display: flex;
    flex-direction: column;
  }

  .reco_aos_product_bundle_item__oc-link {
    width: 100%;
  }

  .reco_aos_product_bundle_item__link {
    text-decoration: none;
    color: black;
  }

  .reco_aos_product_bundle_item__parent_container {
    display: flex;
    justify-content: space-between;
    flex-grow: 1;
  }

  .reco_aos_product_bundle_item__left_side {
    display: flex;
  }

  .reco_aos_product_bundle_item__right_side {
    display: flex;
    width: 80px;
    flex-direction: column;
    align-items: flex-end;
    flex-shrink: 0;
    margin-left: 8px;
    text-wrap: nowrap;
  }

  .reco_aos_product_bundle_item__name {
    text-overflow: ellipsis;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow-wrap: anywhere;
  }

  .reco_aos_product_bundle_item__right_side .line-through {
    text-decoration: line-through;
  }

  .reco_aos_product_bundle_item__right_side .color-red {
    color: var(--oc-semantic-color-brand);
  }
</style>
